import packageJson from "../../package.json";

export const appVersion =
  localStorage.getItem("app-version") || packageJson.version;
